import { LineChart, Line, ResponsiveContainer } from "recharts";
import { getMonthlyTrend } from "@/lib/mock-data";

export function SparklineChart() {
  const data = getMonthlyTrend();

  const latest = data[data.length - 1]?.revenue ?? 0;
  const prev = data[data.length - 2]?.revenue ?? 0;
  const trending = latest >= prev ? "up" : "down";

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 min-h-0">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <Line
              type="monotone"
              dataKey="revenue"
              stroke="#4B75F2"
              strokeWidth={2}
              dot={{ r: 3, fill: "#4B75F2", strokeWidth: 0 }}
              activeDot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-2 text-center">
        <span className="text-[11px] text-[#5A6A68]">
          Trending{" "}
          <span
            className="font-mono font-medium"
            style={{ color: trending === "up" ? "#44F2D2" : "#CC2936" }}
          >
            {trending === "up" ? "+" : "-"}
            {Math.abs(latest - prev).toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 0,
            })}
          </span>{" "}
          vs last month
        </span>
      </div>
    </div>
  );
}
